const txteng8 = [
  ["они уезжают.", "they are leaving."],
  ["я часто спрашиваю их об этом.", "I often ask them about it."],
  ["почему ты не спишь?", "Why aren't you sleeping?"],
  ["я думаю, она чувствует себя хорошо.", "I think she feels well."],
  ["Когда он пришел?", "When did he come?"],
  ["Когда вы обычно приходите домой?", "When d'you normally come home?"],
  ["Он не знает, где она живет.", "He doesn't know where she lives."],
  ["Я ничего не вижу.", "I can't see anything."],
  ["Что она вчера делала?", "What did she do yesterday?"],
  ["Разве ты не узнаешь меня?", "Don't you recognize me?"],
  ["Что ты хочешь?", "What d'you want?"],
  ["Когда она звонила нам в последний раз?", "When did she last call us?"],
  ["Кто тебе звонил?", "Who called you?"],
  ["Кому ты звонил?", "Who did you call?"],
  [
    "Разве ты не знаешь, где они сейчас работают?",
    "Don't you know where they are working?",
  ],
  [
    "Мы встретились в центре и пошли пешком домой.",
    "We met in the center and walked home.",
  ],
  ["Я редко покупаю там продукты.", "I rarely buy food there."],
  ["Что она сейчас покупает?", "What is she buying?"],
  ["Она купила вчера новый ноутбук?", "Did she buy a new laptop yesterday?"],
  ["Ты где?", "Where are you?"],
  ["Где ты был на прошлые выходные?", "Where were you last weekend?"],
  [
    "Мы удивились, когда она сказала это.",
    "We are surprised when she said it.",
  ],
  [
    "Я ничего не готовил, потому что я не хотел есть.",
    "I didn't cook anything because I wasn't hungry.",
  ],
  ["Хочешь пить?", "Are you thirsty?"],
  ["Я никогда не пью днем.", "I never drink in the afternoon."],
  [
    "Вы заняты? Я хочу поговорить с вами.",
    "Are you busy? I want to talk to you.",
  ],
  ["Она ничего нам не рассказала.", "She didn't tell us anything."],
  [
    "Почему бы тебе не рассказать все ему?",
    "Why don't you tell him everything?",
  ],
  ["Она редко звонит мне.", "She rarely calls me."],
  ["Он меня сейчас не понимает.", "He doesn't understand me now."],
  ["Где они вчера были?", "Where were they yesterday?"],
  ["Она не верит, что он сейчас готовит.", "She doesn't belive he's cooking."],
  ["Когда это случилось?", "When did it happen?"],
  [
    "Они не знают, что ему нужны деньги.",
    "They don't know that he needs money.",
  ],
];

export default txteng8;
